module.exports = "/_next/static/images/tailingsdam-2-6caff3405394e8b42cc19c2161b0589a.png";